import React from 'react';
import { __t } from '../../utils/t';

import { ReactComponent as TelegramIcon } from '../../assets/img/telegram.svg';
import { ReactComponent as ViberIcon } from '../../assets/img/viber.svg';
import { ReactComponent as WhatsAppIcon } from '../../assets/img/whatsapp.svg';

import './styles.scss';

export type MessengerName = 'viber' | 'telegram' | 'whatsapp';

interface Props {
    checked: boolean;
    type: MessengerName;
    className?: string;
}

export const MessengerSwitch = ({ checked, type, className = '' }: Props) => {
    const getIcon = () => {
        switch (type) {
            case 'telegram':
                return (
                    <TelegramIcon
                        className={`app-messenger-switch__icon ${
                            checked ? '' : 'app-messenger-switch__icon--disabled'
                        }`}
                    />
                );
            case 'viber':
                return (
                    <ViberIcon
                        className={`app-messenger-switch__icon ${
                            checked ? '' : 'app-messenger-switch__icon--disabled'
                        }`}
                    />
                );
            case 'whatsapp':
                return (
                    <WhatsAppIcon
                        className={`app-messenger-switch__icon ${
                            checked ? '' : 'app-messenger-switch__icon--disabled'
                        }`}
                    />
                );
            default:
                console.error(`Unsupported messenger ${type} type provided!`);
        }
    };

    const getMessengerName = () => {
        switch (type) {
            case 'telegram':
                return __t('Telegram');
            case 'viber':
                return __t('Viber');
            case 'whatsapp':
                return __t('WhatsApp');
            default:
                console.error(`Unsupported messenger ${type} type provided!`);
        }
    };
    return (
        <label className={`app-messenger-switch ${className}`}>
            {getIcon()}
            <span className='app-messenger-switch__text'>{getMessengerName()}</span>
            <input
                className='app-messenger-switch__input'
                type='checkbox'
                checked={checked}
                onChange={() => console.log(1)}
            />
            <span className='app-messenger-switch__switcher'></span>
        </label>
    );
};
